import React from 'react';
import ModalWithoutTitle from 'components/ui/ModalWithoutTitle';

import modalIcon from 'images/icons/build/add-icon.svg';

export default function CreateMethod({ show, onHide, onChoose }) {
  return (
    <ModalWithoutTitle show={show} onHide={onHide}>
      <div className="build_program-modal create_program-modal">
        <div className="programModal_logo">
          <img src={modalIcon} alt="modal image" />
        </div>
        <div className="programModal_title text-h3">Add Manager</div>

        <div className="programModal_txt">
          <p>
            Would you like to choose one of the existing members or create a new manager?
          </p>
        </div>
        <div className="programModal_buttons">
          <button
            type="button"
            onClick={() => onChoose('member')}
            className="button-use "
          >
            Choose Member
          </button>
          <button
            type="button"
            onClick={() => onChoose('new')}
            className="button-create bckg-green"
          >
            Create New
          </button>
        </div>
      </div>
    </ModalWithoutTitle>
  );
}
